<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>ERP Class</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="erp_class_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add ERP Class</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="erp_class_super_master_list"
                          v-model="addedItem.erp_class" label="Select ERP Class"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.erp_class" dense rounded outlined persistent-hint
                          :disabled="editedIndex != -1" hint="
                            noneditable
                          " label="ERP Class"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      erp_class: false,
    },
    snackbar_msg: "",

    // extraBreadcrumbItems: [
    //   { text: "ERP Class Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    erp_class_super_master_list: null,
    headers: [
      {
        text: "ERP Class",
        align: "left",
        sortable: false,
        value: "erp_class",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    erp_class_list: [],
    editedIndex: -1,
    addedItem: {
      erp_class: "",
    },
    editedItem: {
      id: "",
      erp_class: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      erp_class: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New ERP Class" : "Edit ERP Class";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.feesComponent = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/RoleManagement/getERPClass")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.erp_class_super_master_list =
              res.data.erp_class_super_master_list;
            this.erp_class_list = res.data.erp_class_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.erp_class_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.erp_class_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.erp_class_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/RoleManagement/editERPClass", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.erp_class_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "ERP Class updated successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.addedItem.erp_class = "";
            });

          this.close();
        }
      } else {
        axios
          .post("/RoleManagement/saveERPClass", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.erp_class_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "ERP Class added successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "ERP Class already present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.erp_class = "";
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.erp_class) {
        return true;
      } else {
        if (!this.editedItem.erp_class) {
          this.errorMsg.erp_class = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
